import { alpha, toggleButtonClasses } from "@mui/material";
const MuiToggleButton = {
    styleOverrides: {
        root: ({ theme })=>({
                fontSize: 14,
                fontWeight: 'normal',
                padding: '5px 12px',
                color: theme.palette.text.primary,
                borderColor: theme.palette.border.prominent,
                [`&.${toggleButtonClasses.disabled}`]: {
                    borderColor: theme.palette.border.prominent,
                    backgroundColor: alpha(theme.palette.background.hover, 0.5)
                },
                [`&.${toggleButtonClasses.root}.${toggleButtonClasses.root}.${toggleButtonClasses.selected}`]: {
                    backgroundColor: theme.palette.primary.lowContrast,
                    borderColor: theme.palette.primary.main,
                    ["&:hover"]: {
                        backgroundColor: theme.palette.primary.lowContrast
                    }
                },
                '.Chronoui-startIcon': {
                    marginRight: '4px',
                    lineHeight: '10px'
                },
                '.MuiSvgIcon-root': {
                    width: '20px',
                    height: '20px'
                }
            })
    }
};
export { MuiToggleButton };

//# sourceMappingURL=togglebutton-overrides.js.map